import { createSelector } from "@ngrx/store";

import * as fromFeature from "../reducers";
import * as fromCourses from "../reducers/courses.reducer";

// get teacher-classes state
export const getStudentCoursesState = createSelector(
    fromFeature.getStudentCoursesModuleState,
    (state: fromFeature.StudentCoursesState) => state.courses
);

// get teacher-classes entities
export const getStudentCoursesEntities = createSelector(
    getStudentCoursesState,
    fromCourses.getStudentCoursesEntities
);

export const getAllStudentCourses = createSelector(
    getStudentCoursesEntities,
    entities => {
        return Array.from(entities.values());
    }
);

export const getStudentCoursesLoading = createSelector(
    getStudentCoursesState,
    fromCourses.getStudentCoursesLoading
);

export const getStudentCoursesLoaded = createSelector(
    getStudentCoursesState,
    fromCourses.getStudentCoursesLoaded
);

export const getSelectedCourse = createSelector(
    getStudentCoursesState,
    fromCourses.getSelectedCourse
);
